/**
 * Work page "Show All" toggle (sections/work-categories.liquid).
 *
 * Flips the page between the category cards and the all-projects mosaic
 * by toggling `is-inverted` on <html> — the full-page ink inversion CSS
 * lives in critical.css. State persists in the URL as #all so the
 * mosaic view is deep-linkable.
 *
 * init() re-runs on the theme editor's shopify:section:load (each
 * setting tweak replaces the section's DOM, orphaning old bindings).
 */
import { dockInHeader } from './header-slot.js';

const root = document.documentElement;
let btn = null;
let label = null;
let eyebrow = null;

const apply = (on) => {
  if (!btn) return;
  root.classList.toggle('is-inverted', on);
  btn.setAttribute('aria-pressed', String(on));
  label.textContent = on ? btn.dataset.labelCategories : btn.dataset.labelAll;
  if (eyebrow) {
    eyebrow.textContent = on ? eyebrow.dataset.labelAll : eyebrow.dataset.labelDefault;
  }
  history.replaceState(null, '', on ? '#all' : location.pathname + location.search);
};

function init() {
  btn = document.querySelector('.work-toggle');
  if (!btn) return;
  label = btn.querySelector('.work-toggle__label');
  eyebrow = document.querySelector('.work-categories__eyebrow');
  btn.addEventListener('click', () => apply(!root.classList.contains('is-inverted')));
  dockInHeader(btn); // phones: rides in the header bar's left slot
  if (location.hash === '#all') apply(true);
}

window.addEventListener('hashchange', () => apply(location.hash === '#all'));
init();
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.work-toggle')) init();
});
